// Version : 0.0.1
// Author :
// LastEdit : 
// Last ADD : INITIAL CREATION
// MODIFIED DATE: 

import { takeLatest, put, all, call } from 'redux-saga/effects';
import ThriftReportActionTypes from './thrift-report.types';
import { fetchThriftReport } from './thrift-report.service';
import {
	// FETCH THRIFT REPORT RESPONSE
	fetchThriftReportSuccess,
	fetchThriftReportFailure,
	fetchThriftReportResponseChanged,
} from './thrift-report.action';
import { encryptData } from '../../_common/enode-decode';

import AlertManager from '../../../utils/alertManager';

/** *********************  START FETCH THRIFT REPORT DETAILS ******************** */
export function* fetchThriftReportDetails({ payload }: any) {
	try {
		const key = 'GetThriftReportKey';
		const {
			companyID,
			branchID,
			centerID,
			memberID,
			databaseName,
			fromDate,
			toDate,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			BranchID: branchID,
			CenterID: centerID,
			MemberID: memberID,
			DatabaseName: databaseName,
			FromDate: fromDate,
			ToDate: toDate,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchThriftReport, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchThriftReportFailure(responseData.data));
		} else {
			yield put(fetchThriftReportSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchThriftReportFailure(error));
	}
}

export function* resetFetchThriftReportResponse() {
	yield put(fetchThriftReportResponseChanged());
}

export function* onFetchThriftReport() {
	yield takeLatest(ThriftReportActionTypes.FETCH_THRIFT_REPORT_START, fetchThriftReportDetails);
}

export function* onFetchThriftReportResponseReset() {
	yield takeLatest(
		ThriftReportActionTypes.FETCH_THRIFT_REPORT_RESPONSE_RESET,
		resetFetchThriftReportResponse,
	);
}
/** ********************* END FETCH THRIFT REPORT DETAILS ******************** */

export function* thriftReportSaga() {
	yield all([
		call(onFetchThriftReport),
		call(onFetchThriftReportResponseReset),
	]);
}

